import axios from 'src/utils/axios';
import { API_BASE_URL } from 'src/config';

export const GET_BRANCH_CONTACT_TITLES = '@branchContactTitle/get-branch-contact-titles';
export const REQUEST_BRANCH_CONTACT_TITLES = '@branchContactTitle/request-branch-contact-titles';

export function getBranchContactTitles() {
  const request = axios.get(`${API_BASE_URL}/branch-contact-title`);

  return (dispatch) => {
    dispatch({ type: REQUEST_BRANCH_CONTACT_TITLES });

    request
      .then((response) =>
        dispatch({
          type: GET_BRANCH_CONTACT_TITLES,
          payload: { branchContactTitles: response.data }
        })
      )
      .catch((error) => {
        let message = '';
        if (error.response) {
          message = error.response.data;
        }
        dispatch({
          type: GET_BRANCH_CONTACT_TITLES,
          payload: { branchContactTitles: [], message }
        });
      });
  };
}
